import _ from 'lodash';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  FieldStates,
  FormFieldFile
} from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { ClientErrorsState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { SelectBox, SelectBoxOption } from 'sos-common/js/components/FormControls/SelectBox';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { Conditional } from '../../../components/ConditionalField';
import { InternalRegistries } from '../../../components/statistics/internalRegistries';
import { StatisticsOrderModel } from '../../../models';
import {
  statisticsOrderFiles,
  StatisticsOrderRegisters,
  StatisticsOrderStore
} from '../../../models/StatisticsOrderStore.types';
import {
  addFileActionFunc,
  addFilesAction,
  removeFileActionFunc,
  removeFilesAction,
  setFormValue,
  clearError,
  clearErrorDispatcher
} from 'sos-eservice-common/js/Redux/Actions';
import {
  fileInputAcceptedTypes,
  getErrorMessageByFieldName,
  getValidationResultByFieldName
} from '../../../utilities/helpers';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import { countryList } from './dhsCountries';

// todo: complete props
export interface Step2Props extends StepChildProps {
  Translate?: translateFunc;
  files: statisticsOrderFiles;
  validationResults: ValidationResult[];
  orderId: string;
  postFile: addFileActionFunc;
  deleteFile: removeFileActionFunc;
  setFormValue?: typeof setFormValue;
  formModel: StatisticsOrderModel;
  registers?: StatisticsOrderRegisters;
  clearError: clearError;
  errors: ClientErrorsState;
}

export interface Step2State {}

function dhsCountriesToLanKod(
  countries: typeof countryList
): SelectBoxOption[] {
  return countries.map((c) => {
    return {
      key: c.Landkod,
      text: c.Land
    } as SelectBoxOption;
  });
}
function dhsCountriesToLandsnr(
  countries: typeof countryList
): SelectBoxOption[] {
  return countries.map((c) => {
    return {
      uuid: c.Recno,
      key: c.Landsnr,
      text: `${c.Land} (+${c.Landsnr})`
    } as SelectBoxOption;
  });
}

class Step2 extends React.Component<Step2Props, Step2State> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }

  getTitle = () => 'Beställare';

  addFiles = (field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.postFile(field);
  }
  removeFile = (
    file: FileExtendedDetails,
    fieldName: string,
    field: FormFieldFile
  ) => {
    this.props.clearError(field);
    this.props.deleteFile(file, fieldName);
  }

  onChangeField = (field: FieldStates) => {
    this.props.setFormValue(field);
  }

  componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle()
    });
  }

  render() {
    const {
      Translate,
      formModel: statisticsOrder,
      files,
      orderId: statisticsOrderId,
      validationResults,
      registers
    } = this.props;
    const noOrderId = !statisticsOrderId;

    return (
      <div id='step2' tabIndex={-1}>
        <div className='form-group-small'>
          <div>
            <h2 className='inlineblock'>
              {Translate('/statisticsOrderFormPage/Bestallare')}
            </h2>
          </div>
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/contact/namn') + ' *'}
            placeholder={Translate('/general/contact/fnAndEn')}
            value={_.get(statisticsOrder, 'ContactPerson.Name')}
            isRequired={true}
            maxLength={160}
            fieldName='StatisticsOrder.ContactPerson.Name'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'ContactPerson.Name'
            )}
            autoComplete="name"
          />
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/contact/ogNamn1') + ' *'}
            placeholder={Translate('/general/contact/ogNamn2')}
            value={_.get(statisticsOrder, 'ContactPerson.Organisation')}
            isRequired={true}
            maxLength={160}
            fieldName='StatisticsOrder.ContactPerson.Organisation'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'ContactPerson.Organisation'
            )}
            autoComplete="organization"
          />
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/contact/epost') + ' *'}
            placeholder={Translate('/general/contact/abcmail')}
            value={_.get(statisticsOrder, 'ContactPerson.Email')}
            isRequired={true}
            maxLength={160}
            fieldName='StatisticsOrder.ContactPerson.Email'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'ContactPerson.Email'
            )}
            autoComplete="email"
          />
        </div>

        <div className='form-group-small'>
          <div>
            <TextInput
              label={Translate('/general/contact/telf') + ' *'}
              placeholder={Translate('/general/contact/examplePhoneNr')}
              value={_.get(statisticsOrder, 'ContactPerson.Phone')}
              isRequired={true}
              maxLength={26}
              fieldName='StatisticsOrder.ContactPerson.Phone'
              onChange={this.onChangeField}
              pattern='^[\+0](?:\d\s?)+$'
              errorMessage={getErrorMessageByFieldName(
                validationResults,
                'ContactPerson.Phone'
              )}
              autoComplete="tel-national"
            />
            <br />
            <div className='form-group__halfsize'>
              <SelectBox
                options={dhsCountriesToLandsnr(countryList)}
                disableDefaultOption={true}
                fieldName='StatisticsOrder.ContactPerson.CountryCode'
                value={_.get(statisticsOrder, 'ContactPerson.CountryCode', 46)}
                onChange={this.onChangeField}
                errorMessage={getErrorMessageByFieldName(
                  validationResults,
                  'ContactPerson.CountryCode'
                )}
              />
            </div>
          </div>
        </div>

        <hr className='formdivider' />

        <div className='form-group-small'>
          <div>
            <h2 className='inlineblock'>
              {Translate('/statisticsOrderFormPage/BillingTitle')}
            </h2>
          </div>
        </div>

        <div className='form-group-small'>
          <SelectBox
            label={Translate('/statisticsOrderFormPage/BillingCountry') + ' *'}
            options={dhsCountriesToLanKod(countryList)}
            value={_.get(
              statisticsOrder,
              'BillingDetails.BillingAddress.Country',
              'SWE'
            )}
            disableDefaultOption={true}
            fieldName='StatisticsOrder.BillingDetails.BillingAddress.Country'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'BillingDetails.BillingAddress.Country'
            )}
          />
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/contact/ogNamn1') + ' *'}
            placeholder={Translate('/general/contact/ogNamn1Placeholder')}
            value={_.get(statisticsOrder, 'BillingDetails.Organisation')}
            isRequired={true}
            maxLength={160}
            fieldName='StatisticsOrder.BillingDetails.Organisation'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'BillingDetails.Organisation'
            )}
            autoComplete="organization"
          />
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/contact/vatNrTitle') + ' *'}
            placeholder={Translate('/general/contact/vatNrPlaceholder')}
            value={_.get(statisticsOrder, 'BillingDetails.OrganisationNumber')}
            isRequired={true}
            maxLength={14}
            fieldName='StatisticsOrder.BillingDetails.OrganisationNumber'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'BillingDetails.OrganisationNumber'
            )}
            //turning autocomplete off, because there is no standardized value 
            //for org.nr and chrome suggest org.name instead, which is wrong
            autoComplete="off" 
          />
        </div>

        <div className='form-group-small'>
          <TextInput
            additionalText={Translate('/general/contact/billingRefAdditional')}
            label={Translate('/general/contact/billingRef') + ' *'}
            placeholder={Translate('/general/contact/billingRefPlaceHolder')}
            value={_.get(statisticsOrder, 'BillingDetails.BillingReference')}
            isRequired={true}
            maxLength={26}
            fieldName='StatisticsOrder.BillingDetails.BillingReference'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'BillingDetails.BillingReference'
            )}
          />
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/address/BillingAddres')}
            placeholder={Translate('/general/address/gatuEllerBoxPlaceholder')}
            value={_.get(
              statisticsOrder,
              'BillingDetails.BillingAddress.StreetAddress'
            )}
            isRequired={false}
            maxLength={160}
            fieldName='StatisticsOrder.BillingDetails.BillingAddress.StreetAddress'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'BillingDetails.BillingAddress.StreetAddress'
            )}
            autoComplete="street-address"
          />
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/address/postnummer3') + ' *'}
            placeholder={Translate('/general/address/postnummerPlaceholder')}
            value={_.get(
              statisticsOrder,
              'BillingDetails.BillingAddress.ZipCode'
            )}
            isRequired={true}
            maxLength={10}
            fieldName='StatisticsOrder.BillingDetails.BillingAddress.ZipCode'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'BillingDetails.BillingAddress.ZipCode'
            )}
            autoComplete="postal-code"
          />
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/address/ortLabel') + ' *'}
            placeholder={Translate('/general/address/ortPlaceholder')}
            value={_.get(statisticsOrder, 'BillingDetails.BillingAddress.City')}
            isRequired={true}
            maxLength={160}
            fieldName='StatisticsOrder.BillingDetails.BillingAddress.City'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'BillingDetails.BillingAddress.City'
            )}
            autoComplete="address-level1"
          />
        </div>
      </div>
    );
  }
}

const mapState2Props = (state: StatisticsOrderStore) => {
  return {
    errors: state.errors,
    files: state.files,
    formModel: state.formModel,
    orderId: state.globals.orderId,
    registers: state.registers,
    stepValidationMap: state.validationState.stepValidationMap,
    Translate: makeTranslator(state.globals.translations),
    validationResults: state.validationState.validationResults
  } as Partial<Step2Props>;
};

const mapDispatch2Props = (dispatch) => {
  return {
    clearError: clearErrorDispatcher(dispatch),
    deleteFile: bindActionCreators(removeFilesAction, dispatch),
    postFile: bindActionCreators(addFilesAction, dispatch),
    setFormValue: bindActionCreators(setFormValue, dispatch)
  };
};

const StepTwo = connect(
  mapState2Props,
  mapDispatch2Props
)(Step2);
export { StepTwo };
